import BeneficiariesContainer from "./BeneficiariesContainer";

export default BeneficiariesContainer;
